import React from "react";
import { Container } from "react-bootstrap";
import ListView from "../../../components/listView/ListView";
import { categoryFilterMeta } from "../../../configs/meta/filterMeta/categoryFilterMeta";
import categoryListViewMeta from "../../../configs/meta/listViewMeta/categoryListViewMeta";

const Category = () => (
  <React.Fragment>
    <Container fluid className="p-0">
      <ListView
        filters={categoryFilterMeta}
        meta={categoryListViewMeta()}
        title="Category List"
      />
    </Container>
  </React.Fragment>
);

export default Category;
